/*import { Suspense, lazy, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import classes from './App.module.css';
import Home from './pages/Home';
//import Cursor from './components/Cursor/Cursor';


import BookingSection from "./components/BookingSection";
import PartnerCompanies from "./components/PartnerCompanies/PartnerCompanies";
import ScheduleMeeting from "./components/ScheduleMeeting";



import WebDeveloper from "./pages/hire-expert/WebDeveloper";
import MobileAppDeveloper from "./pages/hire-expert/MobileAppDeveloper";
import DigitalMarketer from "./pages/hire-expert/DigitalMarketer";
import BlockchainDeveloper from "./pages/hire-expert/BlockchainDeveloper";



import EventDetails from './components/Events/EventDetails';
import GoToTop from './components/GoToTop';
import Loading from './components/Loading';
import About from './pages/About';
import Apply from './pages/Apply';
import Blogs from './pages/Blogs';
import Events from './pages/Events';
import ExpertiseSolutions from './pages/ExpertiseSolutions';
import Investors from './pages/Investors';
import ProductEngineering from './pages/ProductEngineering';
import Research from './pages/Research';
import TalentPartnership from './pages/TalentPartnership';



import Inv from './components/Investor/Inv';





const Careers = lazy(() => import('./pages/Careers'))
const Contact = lazy(() => import('./pages/Contact'))
const Products = lazy(() => import('./pages/Products'))
const Services = lazy(() => import('./pages/Services'))
const NotFound = lazy(() => import('./pages/NotFound'))

function App() {
  const [loading, setLoading] = useState(true)
  const spinner = document.getElementById('spinner')

  if (spinner) {
    setTimeout(() => {
      spinner.style.display = 'none'
      setLoading(false)
    }, 2000);
  }

  return (
    !loading && (<div className={classes.app}>
      {/* <Cursor /> *
      <Suspense fallback={<div style={{ display: 'grid', placeitems: 'center', minHeight: '100vh' }}><Loading /></div>}>
        <GoToTop />
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/aboutUs' element={<About />} />
          <Route path='/services' element={<Services />} />
          <Route path='/iqverse' element={<Products />} />
          <Route path='/research-and-development' element={<Research />} />
          <Route path='/contact-us' element={<Contact />} />
          <Route path='/careers' element={<Careers />} />
          <Route path='/blogs' element={<Blogs />} />
          <Route path='/talent-partnership' element={<TalentPartnership />} />
          <Route path='/product-engineering' element={<ProductEngineering />} />
          <Route path='/expertise-solutions' element={<ExpertiseSolutions />} />




          {/* 🔹 Fix route here 
          <Route path='/investors' element={<Investors />} />
          <Route path="/partner-companies" element={<PartnerCompanies />} />
          <Route path="/schedule-meeting" element={<ScheduleMeeting />} />
          <Route path="/investor" element={<Inv />} />





          <Route path='/event' element={<Events />} />
          <Route path='/events/:id' element={<EventDetails />} />
          <Route path='/apply/:domain' element={<Apply />} />

          <Route path='/book-meeting' element={<BookingSection />} />

          {/* Hire Expert pages 
          <Route path="/hire-expert/web-developer" element={<WebDeveloper />} />
          <Route path="/hire-expert/mobile-app-developer" element={<MobileAppDeveloper />} />
          <Route path="/hire-expert/digital-marketer" element={<DigitalMarketer />} />
          <Route path="/hire-expert/blockchain-developer" element={<BlockchainDeveloper />} />

          {/* Keep NotFound LAST 
          <Route path='*' element={<NotFound />} />

        </Routes>
      </Suspense>
    </div>)
  );
}

export default App;*/









import { Suspense, lazy, useEffect, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import classes from './App.module.css';

import GoToTop from './components/GoToTop';
import Loading from './components/Loading';

import Home from './pages/Home';
import About from './pages/About';
import Blogs from './pages/Blogs';
import Events from './pages/Events';
import Apply from './pages/Apply';
import Research from './pages/Research';
import Investors from './pages/Investors';
import ExpertiseSolutions from './pages/ExpertiseSolutions';
import ProductEngineering from './pages/ProductEngineering';
import TalentPartnership from './pages/TalentPartnership';

import EventDetails from './components/Events/EventDetails';
import BookingSection from "./components/BookingSection";
import PartnerCompanies from "./components/PartnerCompanies/PartnerCompanies";
import ScheduleMeeting from "./components/ScheduleMeeting";

import WebDeveloper from "./pages/hire-expert/WebDeveloper";
import MobileAppDeveloper from "./pages/hire-expert/MobileAppDeveloper";
import DigitalMarketer from "./pages/hire-expert/DigitalMarketer";
import BlockchainDeveloper from "./pages/hire-expert/BlockchainDeveloper";

import Inv from './components/Investor/Inv';

const Careers = lazy(() => import('./pages/Careers'));
const Contact = lazy(() => import('./pages/Contact'));
const Products = lazy(() => import('./pages/Products'));
const Services = lazy(() => import('./pages/Services'));
const NotFound = lazy(() => import('./pages/NotFound'));

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);

      // ✅ Cleanly hide HTML fallback loader
      const htmlLoader = document.getElementById('initial-loader');
      if (htmlLoader) {
        htmlLoader.classList.add('hidden');
        setTimeout(() => htmlLoader.remove(), 300);
      }

    }, 800);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <div style={{ display: 'grid', placeItems: 'center', minHeight: '100vh' }}>
        <Loading />
      </div>
    );
  }

  return (
    <div className={classes.app}>
      <Suspense
        fallback={
          <div style={{ display: 'grid', placeItems: 'center', minHeight: '100vh' }}>
            <Loading />
          </div>
        }
      >
        <GoToTop />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/aboutUs" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/iqverse" element={<Products />} />
          <Route path="/research-and-development" element={<Research />} />
          <Route path="/contact-us" element={<Contact />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/talent-partnership" element={<TalentPartnership />} />
          <Route path="/product-engineering" element={<ProductEngineering />} />
          <Route path="/expertise-solutions" element={<ExpertiseSolutions />} />

          <Route path="/investors" element={<Investors />} />
          <Route path="/investor" element={<Inv />} />
          <Route path="/partner-companies" element={<PartnerCompanies />} />
          <Route path="/schedule-meeting" element={<ScheduleMeeting />} />

          <Route path="/event" element={<Events />} />
          <Route path="/events/:id" element={<EventDetails />} />
          <Route path="/apply/:domain" element={<Apply />} />
          <Route path="/book-meeting" element={<BookingSection />} />

          {/* Hire Expert */}
          <Route path="/hire-expert/web-developer" element={<WebDeveloper />} />
          <Route path="/hire-expert/mobile-app-developer" element={<MobileAppDeveloper />} />
          <Route path="/hire-expert/digital-marketer" element={<DigitalMarketer />} />
          <Route path="/hire-expert/blockchain-developer" element={<BlockchainDeveloper />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </div>
  );
}

export default App;
